import { styled } from '@mui/material/styles';

import type { DealApi } from '@openx/types/deal';
import { usePermissionContext } from '@openx/utils/permission/context/PermissionContext';

import type { IUseParticipantFunctions } from '../../utils/context/DealHookTypes';

import { Participant } from './Participant';

const StyledParticipantContainerDiv = styled('div')<{ isOa: boolean }>`
  margin-bottom: ${({ theme }) => theme.spacing(2)};
  padding-bottom: ${({ theme }) => theme.spacing(2)};
  &:last-of-type {
    margin-bottom: ${({ theme, isOa }) => (isOa ? 0 : theme.spacing(2))};
    padding-bottom: ${({ theme, isOa }) => (isOa ? 0 : theme.spacing(2))};
  }
`;

export type ParticipantsDemandPartnersDeal = Pick<
  DealApi,
  'enable_dv360_inventory_package' | 'deal_participants' | 'pmp_deal_type' | 'pdp_config' | 'currency'
>;

export type ParticipantsDemandPartnersProps<T extends ParticipantsDemandPartnersDeal> = {
  deal: T;
  useParticipantFunctions: IUseParticipantFunctions;
};

export function ParticipantsDemandPartners<T extends ParticipantsDemandPartnersDeal>({
  deal,
  useParticipantFunctions,
}: ParticipantsDemandPartnersProps<T>) {
  const participantFunctions = useParticipantFunctions();
  const { isOa } = usePermissionContext();

  const { enable_dv360_inventory_package } = deal;

  return (
    <>
      {(deal.deal_participants || []).map(({ brand_ids = {}, demand_partner = '', buyer_ids = {}, main_buyer_id }) => (
        <StyledParticipantContainerDiv
          isOa={!!isOa}
          key={`${demand_partner}-${Object.keys(buyer_ids).toString()}`}
          data-test="dsp-wrapper"
        >
          <Participant
            dealParticipant={{ brand_ids, buyer_ids, demand_partner }}
            mainBuyer={main_buyer_id}
            dealType={deal.pmp_deal_type}
            participantFunctions={participantFunctions}
            enableDv360InventoryPackage={!!enable_dv360_inventory_package}
            pdp_config={deal.pdp_config}
            currency={deal.currency}
          />
        </StyledParticipantContainerDiv>
      ))}
    </>
  );
}
